/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {Feature, GenericObject} from '@ion/core/src/types/entities';
import {safeJSONParse} from '@ion/core/src/utils/JSONUtils';
import {VBUS_ENABLED_STATUS} from '@ion/dls/src/editors/features/ModuleActionHelpers';

/**
 * The useVbusEnabledAccess hook provides the VBus Enabled status based on the current user's role.
 *
 * ```typescript
 * import {useVbusEnabledAccess} from '@ion/packages/query/src/hooks';
 *  ...
 *  const hasVbusAccess = useVbusEnabledAccess(Features);
 *
 */
export const useVbusEnabledAccess = (Features: GenericObject): boolean => {
  const extendedAttribute   = Features?._userRoles?.[0]?.extendedAttribute;
  const currentUserFeatures = extendedAttribute ? safeJSONParse(extendedAttribute?.value) : [];
  const devicesModules      = currentUserFeatures?.features?.find((item: Feature) => item?.name === 'Devices')?.modules || [];
  return !!devicesModules?.find((item) => item.name === VBUS_ENABLED_STATUS && item.enabled === true);
};

export default useVbusEnabledAccess;
